/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBenefitPeriodQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type GetBenefitPeriodQuery = { __typename?: 'Query', surveyBenefitPeriod: { __typename?: 'BenefitPeriod', id: string, benefitPeriod: SchemaTypes.BenefitPeriodLength } };


export const GetBenefitPeriodDocument = gql`
    query GetBenefitPeriod {
  surveyBenefitPeriod {
    id
    benefitPeriod
  }
}
    `;
export function useGetBenefitPeriodQuery(baseOptions?: Apollo.QueryHookOptions<GetBenefitPeriodQuery, GetBenefitPeriodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBenefitPeriodQuery, GetBenefitPeriodQueryVariables>(GetBenefitPeriodDocument, options);
      }
export function useGetBenefitPeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBenefitPeriodQuery, GetBenefitPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBenefitPeriodQuery, GetBenefitPeriodQueryVariables>(GetBenefitPeriodDocument, options);
        }
export function useGetBenefitPeriodSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBenefitPeriodQuery, GetBenefitPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBenefitPeriodQuery, GetBenefitPeriodQueryVariables>(GetBenefitPeriodDocument, options);
        }
export type GetBenefitPeriodQueryHookResult = ReturnType<typeof useGetBenefitPeriodQuery>;
export type GetBenefitPeriodLazyQueryHookResult = ReturnType<typeof useGetBenefitPeriodLazyQuery>;
export type GetBenefitPeriodSuspenseQueryHookResult = ReturnType<typeof useGetBenefitPeriodSuspenseQuery>;
export type GetBenefitPeriodQueryResult = Apollo.QueryResult<GetBenefitPeriodQuery, GetBenefitPeriodQueryVariables>;